import { deepClone } from '@/utils/clone';

export type SavedTimeMapping = (at: number, wallAt: number) => number;
let scopedWallAt: number | undefined;

/** A synchronous scope only: never hold it across a generator yield or await. */
export function withNodeSnapshotTime<T>(wallAt: number, run: () => T): T {
  const previous = scopedWallAt;
  scopedWallAt = wallAt;
  try {
    return run();
  } finally {
    scopedWallAt = previous;
  }
}

export function nodeSnapshotWallAt(): number {
  return scopedWallAt ?? Date.now();
}

/** Copy first; native Delay admission and frozen mapper capture belong to caller. */
export function cloneSavedDelayState<T>(
  state: T,
  mapping: SavedTimeMapping | undefined,
  wallAt: number,
): T {
  const copy = deepClone(state);
  if (!mapping || !copy || typeof copy !== 'object' || Array.isArray(copy)) return copy;
  const saved = copy as Record<string, unknown>;
  if (Array.isArray(saved.queue)) {
    for (const entry of saved.queue) {
      if (entry && typeof entry === 'object' && typeof entry.targetTime === 'number')
        entry.targetTime = mapping(entry.targetTime, wallAt);
    }
  }
  if (typeof saved.lastProcessTime === 'number')
    saved.lastProcessTime = mapping(saved.lastProcessTime, wallAt);
  return copy;
}
